import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import customFetch from '../utils/axios';

const useCustomFetch = () => {
  const { user, token, logout } = useAuth();
  const navigate = useNavigate();

  const handleResponse = async (response) => {
    const contentType = response.headers['content-type'];
    if (!contentType || !contentType.includes('application/json')) {
      throw new Error(`Invalid response format: Expected JSON but received ${contentType}`);
    }

    const data = response.data;
    if (response.status >= 400) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return data;
  };

  const get = useCallback(async (endpoint, config = {}) => {
    try {
      const response = await customFetch.get(endpoint, config);
      return handleResponse(response);
    } catch (error) {
      if (error.response?.status === 401) {
        logout();
        navigate('/login');
      }
      throw error;
    }
  }, [logout, navigate]);

  const post = useCallback(async (endpoint, data, config = {}) => {
    try {
      const response = await customFetch.post(endpoint, data, config);
      return handleResponse(response);
    } catch (error) {
      if (error.response?.status === 401) {
        logout();
        navigate('/login');
      }
      throw error;
    }
  }, [logout, navigate]);

  const put = useCallback(async (endpoint, data, config = {}) => {
    try {
      const response = await customFetch.put(endpoint, data, config);
      return handleResponse(response);
    } catch (error) {
      if (error.response?.status === 401) {
        logout();
        navigate('/login');
      }
      throw error;
    }
  }, [logout, navigate]);

  const del = useCallback(async (endpoint, config = {}) => {
    try {
      const response = await customFetch.delete(endpoint, config);
      return handleResponse(response);
    } catch (error) {
      if (error.response?.status === 401) {
        logout();
        navigate('/login');
      }
      throw error;
    }
  }, [logout, navigate]);

  const patch = useCallback(async (endpoint, data, config = {}) => {
    try {
      const response = await customFetch.patch(endpoint, data, config);
      return handleResponse(response);
    } catch (error) {
      if (error.response?.status === 401) {
        logout();
        navigate('/login');
      }
      throw error;
    }
  }, [logout, navigate]);

  return {
    get,
    post,
    put,
    patch,
    delete: del
  };
};

export default useCustomFetch;